import { Directive,HostBinding,Input,OnInit,ElementRef,Renderer2,Inject} from '@angular/core';
import {AbsDomHelperService} from '../abs-utilities/abs-dom-helper.service';
import {AbsKeymapService} from '../abs-utilities/abs-keymap.service';

@Directive({
	selector: '[abs-trap-focus-inside-element]'
})
export class AbsTrapFocusInsideElementDirective implements OnInit {
	firstTabableElement:any;
	lastTabableElement:any;	
	firstTabableElementBind:any;
	lastTabableElementBind:any;	
	@Input() delay:number;
	@Input('trap-focus-coachmark') coackmark:any;
	@Input('abs-trap-focus-inside-element') set trapFocus(condition:boolean) {
		if (condition) {
			this.bindAll();
		} else {
			this.unBindAll();
		}
	}
	constructor(
		@Inject(ElementRef) private elementRef:ElementRef,
		@Inject(AbsDomHelperService) private domHelper:AbsDomHelperService,
		@Inject(AbsKeymapService) private keymap:AbsKeymapService,
		@Inject(Renderer2) private renderer:Renderer2
	) { }
	ngOnInit() {
		this.delay = this.delay | 10;
	 	// If left as empty string Angular seems to drop the variable declaration later in code
	 	// Don't penalize when someone sets to true or false
	 	if (this.coackmark || this.coackmark === '') {
	 		this.coackmark = true;
	 	} else {
	 		this.coackmark = false;
	 	}		
	}
	bindAll() {
		const el = this.elementRef.nativeElement;
		setTimeout(()=>{
			this.firstTabableElement = this.domHelper.firstTabableElement(el);
			this.lastTabableElement = this.domHelper.lastTabableElement(el);
			this.firstTabableElementBind = this.renderer.listen(this.firstTabableElement,'keydown', this.firstTabableElementKeyhandler.bind(this));
			this.lastTabableElementBind = this.renderer.listen(this.lastTabableElement,'keydown', this.lastTabableElementKeyhandler.bind(this));
		},this.delay);
	}
	unBindAll() {
		if (this.firstTabableElementBind) {
			this.firstTabableElementBind();
		}
		if (this.lastTabableElementBind) {
			this.lastTabableElementBind();
		}
	}
	firstTabableElementKeyhandler(e) {
		if (!e.keyCode) {
			e.keyCode = e.which;
		}
		if (e.keyCode === this.keymap.KEY.TAB && e.shiftKey) {
			if (this.coackmark) {
				const el = this.elementRef.nativeElement;
				const temp = this.domHelper.lastTabableElement(el);
				if (this.lastTabableElement !== temp) {
					this.lastTabableElementBind();
					this.lastTabableElement = temp;
					this.lastTabableElementBind = this.renderer.listen(this.lastTabableElement,'keydown', this.lastTabableElementKeyhandler.bind(this));
				}
			}
            this.lastTabableElement.focus();
            e.preventDefault();
            e.stopPropagation();
    	}
    };
    lastTabableElementKeyhandler(e) {
        if (!e.keyCode) {
            e.keyCode = e.which;
        }
        if (e.keyCode === this.keymap.KEY.TAB && !e.shiftKey) {
			if (this.coackmark) {
				const el = this.elementRef.nativeElement;
				const temp = this.domHelper.firstTabableElement(el);
				if (this.firstTabableElement !== temp) {
					this.firstTabableElementBind();
					this.firstTabableElement = temp;
					this.firstTabableElementBind = this.renderer.listen(this.firstTabableElement,'keydown', this.firstTabableElementKeyhandler.bind(this));
				}
			}
            this.firstTabableElement.focus();
            e.preventDefault();
            e.stopPropagation();
        }
    };    	
}
